import { useEffect } from 'react';

import { SuggestTitleEvents } from './event-enums';

/**
 * EXPERIMENTAL: Util hook for experimental flow where 'Suggest title' in
 * Confluence title toolbar will trigger the 'Suggest a title' flow in Editor AI.
 */
export const useEditorAIReplacingTitle = (
	enabled: boolean,
	handleNewTitle: (title: string) => void,
) => {
	useEffect(() => {
		if (!enabled) {
			return;
		}

		const onReceiveNewTitle = (event: CustomEvent<{ title: string }>) => {
			handleNewTitle(event.detail?.title);
		};

		// eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
		document.addEventListener(
			SuggestTitleEvents.ReplaceConfluenceTitle,
			onReceiveNewTitle as EventListener,
		);

		return () => {
			// eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
			document.removeEventListener(
				SuggestTitleEvents.ReplaceConfluenceTitle,
				onReceiveNewTitle as EventListener,
			);
		};
	}, [handleNewTitle, enabled]);
};
